import styled from 'styled-components';

export const CheckboxBox = styled.label`
  display: inline-block;
  position: relative;
  user-select: none;
`;

export const CheckboxInner = styled.div`
  padding: 2px 0 2px 28px;

  font-size: 14px;
  line-height: 1.3333;
`;

export const CheckboxIcon = styled.div`
  position: absolute;
  z-index: 10;
  top: 3px;
  left: 3px;

  width: 18px;
  height: 18px;

  line-height: 0;

  color: transparent;
  background-color: #FFFFFF;
  border: 2px solid #C4C8CC;
  border-radius: 4px;

  pointer-events: none;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
`;

export const CheckboxText = styled.div`

`;

export const CheckboxField = styled.input`
  display: none;

  position: absolute;
  z-index: 5;
  top: 5px;
  left: 5px;

  width: 14px;
  height: 14px;

  &:checked + ${CheckboxInner} > ${CheckboxIcon} {
    color: #FFFFFF;
    background-color: #0059BE;
    border-color: transparent;
  }

  &:disabled + ${CheckboxInner} > ${CheckboxIcon} {
    background-color: #F7F9FA;
    border-color: #969CA3;
  }

  &:checked:disabled + ${CheckboxInner} > ${CheckboxIcon} {
    background-color: #969CA3;
  }

  &:disabled + ${CheckboxInner} > ${CheckboxText} {
    color: #969CA3;
  }
`;

CheckboxBox.displayName = 'CheckboxBox';
CheckboxInner.displayName = 'CheckboxInner';
CheckboxIcon.displayName = 'CheckboxIcon';
CheckboxText.displayName = 'CheckboxText';
CheckboxField.displayName = 'CheckboxField';
